import { render, staticRenderFns } from "./AddDepartmentComponent.vue?vue&type=template&id=75db97d7&scoped=true"
import script from "./AddDepartmentComponent.vue?vue&type=script&lang=js"
export * from "./AddDepartmentComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75db97d7",
  null
  
)

export default component.exports